/** Бэкенд отвечает CodedError с extensions.code === "CHAT_BANNED". */
export function isChatBannedError(error: unknown): boolean {
  const e = error as {
    graphQLErrors?: { extensions?: { code?: unknown } }[];
  } | null;
  return Boolean(
    e?.graphQLErrors?.some((g) => g.extensions?.code === "CHAT_BANNED"),
  );
}
